import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import VisitCounter from "./VisitCounter";

const LOGO = "https://customer-assets.emergentagent.com/job_study-docs-1c/artifacts/jcrmntic_IMG_0209.jpeg";

const NavBar = ({ active }) => (
  <header className="bg-navy-900/80 backdrop-blur-lg border-b border-white/5 sticky top-0 z-50">
    <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-3">
        <img src={LOGO} alt="Excell-Tutorat" className="h-11 w-auto object-contain" />
      </Link>
      <nav className="flex items-center gap-4 sm:gap-6">
        {[
          { to: "/", label: "Accueil", key: "home" },
          { to: "/sn4", label: "Maths SN4", key: "sn4" },
          { to: "/cst4", label: "Maths CST4", key: "cst4" },
          { to: "/mecanique", label: "Physique", key: "mecanique" },
          { to: "/gratuit", label: "Aides mémoires gratuites", key: "gratuit" },
          { to: "/contact", label: "Contact", key: "contact" },
        ].map(link => (
          <Link
            key={link.key}
            to={link.to}
            className={`text-sm font-medium transition-colors ${
              active === link.key ? "text-amber-400" : "text-blue-200/70 hover:text-amber-400"
            }`}
          >
            {link.label}
          </Link>
        ))}
      </nav>
    </div>
  </header>
);

const Footer = () => (
  <footer className="bg-navy-900 border-t border-white/5 py-12">
    <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        <img src={LOGO} alt="Excell-Tutorat" className="h-12 w-auto object-contain" />
        <span className="font-semibold text-white">Excell-Tutorat</span>
      </div>
      <div className="flex gap-6">
        <Link to="/" className="text-blue-300/50 text-sm hover:text-amber-400 transition-colors">Accueil</Link>
        <Link to="/sn4" className="text-blue-300/50 text-sm hover:text-amber-400 transition-colors">Maths SN4</Link>
        <Link to="/cst4" className="text-blue-300/50 text-sm hover:text-amber-400 transition-colors">Maths CST4</Link>
        <Link to="/mecanique" className="text-blue-300/50 text-sm hover:text-amber-400 transition-colors">Physique</Link>
        <Link to="/gratuit" className="text-blue-300/50 text-sm hover:text-amber-400 transition-colors">Aides mémoires gratuites</Link>
        <Link to="/contact" className="text-blue-300/50 text-sm hover:text-amber-400 transition-colors">Contact</Link>
      </div>
      <p className="text-blue-300/40 text-sm">© 2026 Excell-Tutorat</p>
    </div>
    <div className="max-w-6xl mx-auto px-4 mt-6 pt-4 border-t border-white/5 flex items-center justify-center">
      <VisitCounter />
    </div>
  </footer>
);

export { NavBar, Footer, LOGO };
